<template>
  <div>
    <page-content-toolbar
      projectName="404 NOT FOUND"
    />
    <h2 class="text-center">{{ $t('global.404NotFound') }} :'(</h2>
  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';

export default {
  name: "NotFound",

  components: { PageContentToolbar },
};
</script>